import { useTheme } from "@mui/styles";
import React from "react";
import styled from "styled-components";

const StyledTitle = styled.div`
  font-family: noto-sans;
  font-size: 1.2rem;
  //font-weight: semi-bold;
`;

const BedBuilderHeader = ({ children, styles = {}, className }) => {
  const theme = useTheme();
  return (
    <StyledTitle
      className={className + " mx-auto"}
      style={{ color: theme.COLORS.BLUE.darkBlueGreen, ...styles }}
    >
      {children}
    </StyledTitle>
  );
};

export default BedBuilderHeader;
